import { Field, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { SecretKindEnum } from '../SecretKindEnum'

@InputType()
export class GetSecretStatusArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  /** Arbitrary JSON from the client: only `kind` is read, and the Action type-checks it. */
  filter?: Record<string, unknown>
}

@ObjectType()
export class SecretFieldStatus {
  @Field(() => String)
  name: string

  @Field(() => Boolean)
  isSet: boolean

  @Field(() => String, { nullable: true })
  tail: string | null
}

@ObjectType()
export class SecretStatus {
  @Field(() => SecretKindEnum)
  kind: SecretKindEnum

  @Field(() => [SecretFieldStatus])
  fields: SecretFieldStatus[]
}

export interface IGetSecretStatus extends IAction<SecretStatus[], GetSecretStatusArgs> {}
